import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import PageHeading from '../components/PageHeading/PageHeading';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
import { formDataPost } from "../helpers/Helpers";
import apiFetch from '@wordpress/api-fetch';
const SecurityUpdates = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [selectedFilter, setSelectedFilter] = useState("general_settings");
    const filters = [
        { 'general_settings': "General Settings" },
        { 'plugins_list': "Plugins List" },
        { 'theme_list': "Theme List" },
    ];
    const [adminEmails, setAdminEmails] = useState(null);   
    useEffect(() => {
        const fetchAdminEmails = async () => {
            try {
                const results = await apiFetch({ path: "/ultimate-security/v1/get-admin-emails", method: "GET" });
                // Save to localStorage
                localStorage.setItem("plusAdminEmails", JSON.stringify(results));
                // Update state
                setAdminEmails(results);
            } catch (error) {
                console.error("Error fetching adminEmails:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedAdminEmails = localStorage.getItem("plusAdminEmails");
        if (storedAdminEmails) {
            setAdminEmails(JSON.parse(storedAdminEmails));
        } else {
            fetchAdminEmails();
        }
    }, []);

    const [ui, setUi] = useState({
        email:   { processing: false, ring: false, tick: false },
        update:  { processing: false, ring: false, tick: false },
        pluginRefresh: { processing: false, ring: false, tick: false },
        themeRefresh: { processing: false, ring: false, tick: false },
    });
    
    const handleAction = (action) => {
        // helper to mutate just one branch
        const mutate = (key, changes) =>
            setUi((prev) => ({ ...prev, [key]: { ...prev[key], ...changes } }));
    
        const key = action === 'test_email' ? 'email' : 'update';
    
        mutate(key, { processing: true, ring: true });
    
        switch (action) {
            case 'test_email':
                sendTestEmail();
                break;
            case 'force_update':
                forceUpdate();
                break;
            default:
                console.warn('Unknown action:', action);
        }
    
        // progress‑animation for this action only
        setTimeout(() => {
            mutate(key, { ring: false, tick: true });
    
            setTimeout(() => {
                mutate(key, { tick: false, processing: false });
            }, 1_000);
        }, 3_000);
    };
    

    const sendTestEmail = async () => {
        let result;
        try {
            result = await formDataPost('ultimate_security_send_update_notification_test_email', {});
            if (result.success_message) {
                console.log(result.success_message);
            }
        } catch (error) {
            console.log(error.message);
        } finally {}
    }

    const forceUpdate= async () => {
        let result;
        try {
            result = await formDataPost('ultimate_security_update_core', {});
            if (result==true) {
                console.log('success');
            }
        } catch (error) {
            console.log(error.message);
        } finally {}
    }
    

    // Datatable setup
    const [selectedRows, setSelectedRows] = useState([])
    const [bulkAction, setBulkAction] = useState("-1")



    const [filterList,setFilterList] = useState([
        { key: "type-1", value: "Active" }, 
        { key: "type-2", value: "Inactive" }, 
        { key: "type-3", value: "Update Available" }
    ])
    const [pluginList,setPluginList] = useState([])
    const [pluginRecords, setPluginRecords] = useState([])
    const [themeList,setThemeList] = useState([])
    const [themeRecords, setThemeRecords] = useState([])
    
    const [activePluginFilter, setActivePluginFilter] = useState('')
    const [activeThemeFilter, setActiveThemeFilter] = useState('')

    const [pluginSearchQuery,setPluginSearchQuery] = useState('')
    const [themeSearchQuery,setThemeSearchQuery] = useState('')

    const getValueByPath = (obj, path) => {
        let parts;
    
        if (path.includes("::")) {
            parts = path.split("::");
    
            // Decode plugin file name only
            if (parts[2] === "plugins_functionalities" && parts[3]) {
                parts[3] = decodeURIComponent(parts[3]);
            }
        } else {
            parts = path.split(".");
        }
    
        return parts.reduce((acc, key) => acc && acc[key], obj);
    };


    const pluginListColumns = [
        { 
            id: 'name',
            name: 'Name',
            selector: row => row.plugin_name + ' ' + row.plugin_file,
            sortable: true,
        },
        { 
            id: 'disable_updates',
            name: 'Disable updates',
            cell: row => {
                const key = encodeURIComponent(row.plugin_file);
                const name = `security::updates::plugins_functionalities::${key}::disable_updates`;
                const value = !!Number(getValueByPath(settingData, name));
    
                return (
                    <Switch
                        name={name}
                        checked={value}
                        onChange={handleChange}
                    />
                );
            },
            sortable: false,
        },
        { 
            id: 'auto_updates',
            name: 'Auto-updates',
            cell: row => {
                const key = encodeURIComponent(row.plugin_file);
                const name = `security::updates::plugins_functionalities::${key}::auto_updates`;
                const value = !!Number(getValueByPath(settingData, name));
    
                return (
                    <Switch
                        name={name}
                        checked={value}
                        onChange={handleChange}
                    />
                );
            },
            sortable: false,
        },
        { 
            id: 'translation_updates',
            name: 'Translation updates',
            cell: row => {
                const key = encodeURIComponent(row.plugin_file);
                const name = `security::updates::plugins_functionalities::${key}::translation_updates`;
                const value = !!Number(getValueByPath(settingData, name));
    
                return (
                    <Switch
                        name={name}
                        checked={value}
                        onChange={handleChange}
                    />
                );
            },
            sortable: false,
        },
        { 
            id: 'hide',
            name: 'Hide plugin',
            cell: row => {
                const key = encodeURIComponent(row.plugin_file);
                const name = `security::updates::plugins_functionalities::${key}::hide`;
                const value = !!Number(getValueByPath(settingData, name));
    
                return (
                    <Switch
                        name={name}
                        checked={value}
                        onChange={handleChange}
                    />
                );
            },
            sortable: false,
        }
    ];
    
    
    const themeListColumns =  [
        { 
            id: 'name',
            name: 'Name',
            selector: row => row.theme_name,
            sortable: true,
        },
        { 
            id: 'disable_updates',
            name: 'Disable updates',
            cell: row => (                
                <Switch 
                    name={`security.updates.themes_functionalities.${row.theme_slug}.disable_updates`}
                    checked={settingData?.security?.updates?.themes_functionalities?.[row.theme_slug]?.disable_updates} // Pass "1"/"0" from API 
                    onChange={handleChange} 
                />
            ),
            sortable: false,
        },
        { 
            id: 'auto_updates',
            name: 'Auto-updates',
            cell: row => (
                <Switch 
                    name={`security.updates.themes_functionalities.${row.theme_slug}.auto_updates`}
                    checked={settingData?.security?.updates?.themes_functionalities?.[row.theme_slug]?.auto_updates} // Pass "1"/"0" from API 
                    onChange={handleChange} 
                />
            ),
            sortable: false,
        },
        { 
            id: 'translation_updates',
            name: 'Translation updates',
            cell: row => (
                <Switch 
                    name={`security.updates.themes_functionalities.${row.theme_slug}.translation_updates`}
                    checked={settingData?.security?.updates?.themes_functionalities?.[row.theme_slug]?.translation_updates} // Pass "1"/"0" from API 
                    onChange={handleChange} 
                />
            ),
            sortable: false,
        },
        { 
            id: 'hide',
            name: 'Hide theme',
            cell: row => (
                <Switch 
                    name={`security.updates.themes_functionalities.${row.theme_slug}.hide`}
                    checked={settingData?.security?.updates?.themes_functionalities?.[row.theme_slug]?.hide} // Pass "1"/"0" from API 
                    onChange={handleChange} 
                />
            ),
            sortable: false,
        }
    ]   
    
    useEffect(()=> {
        fetchThemeList();
        fetchPluginList();
    },[])

    const fetchThemeList = async () => {
        try {
            const results = await apiFetch({ 
                path: "/ultimate-security/v1/get-themes-info", 
                method: "GET" 
            });
            setThemeList(results);
            setThemeRecords(results);
        } catch (error) {
            console.error("Error fetching ThemeList:", error);
        }
    };

    const fetchPluginList = async () => {
        try {
            const results = await apiFetch({ 
                path: "/ultimate-security/v1/get-plugins-info", 
                method: "GET" 
            });
            setPluginList(results);
            setPluginRecords(results);
        } catch (error) {
            console.error("Error fetching PluginList:", error);
        }
    }; 
    
    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
        // console.log(selectedRows)
    };
    const handlePluginSearch = (e) => {
        setPluginSearchQuery(e.target.value)
        // setActiveRole('') // Reset the active role
        const newData = pluginList.filter(row => {
            return row.plugin_name.toLowerCase().includes(e.target.value.toLowerCase())
        })
        setPluginRecords(newData)
        setActivePluginFilter('')
    }
    const handleThemeSearch = (e) => {
        setThemeSearchQuery(e.target.value)
        // setActiveRole('') // Reset the active role
        const newData = themeList.filter(row => {
            return row.theme_name.toLowerCase().includes(e.target.value.toLowerCase())
        })
        setThemeRecords(newData)
    }
    const handlePluginFilter = (filter) => {
        setPluginSearchQuery('')
        if (filter == 'All') {
            setPluginRecords(pluginList)        
            setActivePluginFilter(''); // Set the active role
        } else {
            const newData = pluginList.filter(row => {
                return row.plugin_filters.toLowerCase().includes(filter.toLowerCase())
            })
            setPluginRecords(newData)        
            setActivePluginFilter(filter); // Set the active role
        }
    }
    const handleThemeFilter = (filter) => {
        setThemeSearchQuery('')
        if (filter == 'All') {
            setThemeRecords(themeList)        
            setActiveThemeFilter(''); // Set the active role
        } else {
            const newData = themeList.filter(row => {
                return row.theme_filters.toLowerCase().includes(filter.toLowerCase())
            })
            setThemeRecords(newData)        
            setActiveThemeFilter(filter); // Set the active role
        }
    }
    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    
    const handleBulkActionSubmit = () => {
        if (selectedRows.length) {
            const ids = selectedRows.map(item => item.ID);           

            if (bulkAction === "reset") {
                formDataPost('ultimate_security_user_2fa_reset_users',{"user_ids": ids})
                .then(data=> {
                       
                    if(data.success){
                        setBulkAction("-1")
                        setSelectedRows([])

                        getUserList()
                        .then(data=> {
                            if(data){
                                setUserList(data)
                                setRecords(data)
                                setActiveRole('') // Reset the active role
                            }
                        })
                        .catch(err=> console.log(err))

                        alert(data.data.success_message)
                    } else {
                        console.log(data.data.error_message)
                    }
                })
                .catch(err=> {
                    alert(data.data.error_message)
                })

            } else if (bulkAction === "delete") {
            
            } else {
                alert("Please select a valid action.");
            }
        } else {
            alert("Please select users.");
        }
    };
    // 2. Replace the handleClickPluginRefresh function
    const handleClickPluginRefresh = () => {
        const mutate = (key, changes) =>
            setUi((prev) => ({ ...prev, [key]: { ...prev[key], ...changes } }));
    
        // Start loading state
        mutate('pluginRefresh', { processing: true, ring: true });
    
        // Call the fetch function
        fetchPluginList();
        
        // Reset filters and search
        setActivePluginFilter('');
        setPluginSearchQuery('');
    
        // Show success animation after 3 seconds
        setTimeout(() => {
            mutate('pluginRefresh', { ring: false, tick: true });
    
            setTimeout(() => {
                mutate('pluginRefresh', { tick: false, processing: false });
            }, 1_000);
        }, 3_000);
    };
    
    // 3. Replace the handleClickThemeRefresh function
    const handleClickThemeRefresh = () => {
        const mutate = (key, changes) =>
            setUi((prev) => ({ ...prev, [key]: { ...prev[key], ...changes } }));
    
        // Start loading state
        mutate('themeRefresh', { processing: true, ring: true });
    
        // Call the fetch function
        fetchThemeList();
        
        // Reset filters and search
        setActiveThemeFilter('');
        setThemeSearchQuery('');
    
        // Show success animation after 3 seconds
        setTimeout(() => {
            mutate('themeRefresh', { ring: false, tick: true });
    
            setTimeout(() => {
                mutate('themeRefresh', { tick: false, processing: false });
            }, 1_000);
        }, 3_000);
    };
    // Datatable setup

    return (
        <>
            <div className="setting-unit">
                <div className="d-flex align-items-center justify-content-center">
                    <div className="filter-wrapper background-purple-10">
                        {filters && filters.length && 
                            filters.map((filter, index) => {
                                return (
                                <button
                                    key={index}
                                    className={`filter-btn pl-heading-2 ${
                                        selectedFilter === Object.keys(filter)[0]
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                        setSelectedFilter(Object.keys(filter)[0])
                                    }
                                >
                                    <span>{Object.values(filter)[0]}</span>
                                </button>
                                );
                            })
                        }
                    </div>
                </div>                
            </div>
            {
                selectedFilter ==  "general_settings" && 
                <>                
                    <div className="setting-unit pb-lg mb-lg border-bottom pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("General settings for WordPress, plugins and themes updates", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("This page, you can enable or disable automatic updates.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                            <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Core Updates", "ultimate-security")}</h6>
                                        </div>
                                        <div className="content-below-with-hint mt-2">
                                            <select 
                                                className="form-select"
                                                value={settingData?.security?.updates?.core_updates} 
                                                onChange={(e) => handleChange('security.updates.core_updates', e.target.value)}
                                            >
                                                <option value="">{__("Select One", "ultimate-security")}</option>
                                                <option value="disable">{__("Disable updates", "ultimate-security")}</option>
                                                <option value="disable_auto">{__("Disable auto updates", "ultimate-security")}</option>
                                                <option value="minor">{__("Allow minor auto updates", "ultimate-security")}</option>
                                                <option value="major">{__("Allow major auto updates", "ultimate-security")}</option>
                                                <option value="development">{__("Allow development auto updates", "ultimate-security")}</option>
                                            </select>
                                        </div>
                                    </div>     
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Plugin Updates", "ultimate-security")}</h6>
                                        </div>
                                        <div className="content-below-with-hint mt-2">
                                            <select 
                                                className="form-select"
                                                value={settingData?.security?.updates?.plugin_updates} 
                                                onChange={(e) => handleChange('security.updates.plugin_updates', e.target.value)}
                                            >
                                                <option value="manual_updates">{__("Manual updates", "ultimate-security")}</option>
                                                <option value="auto">{__("Enable auto updates", "ultimate-security")}</option>
                                                <option value="disable">{__("Disable updates", "ultimate-security")}</option>
                                            </select>
                                        </div>
                                    </div>     
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Theme Updates", "ultimate-security")}</h6>
                                        </div>
                                        <div className="content-below-with-hint mt-2">
                                            <select 
                                                className="form-select"
                                                value={settingData?.security?.updates?.theme_updates} 
                                                onChange={(e) => handleChange('security.updates.theme_updates', e.target.value)}
                                            >
                                                <option value="manual_updates">{__("Manual updates", "ultimate-security")}</option>
                                                <option value="auto">{__("Enable auto updates", "ultimate-security")}</option>
                                                <option value="disable">{__("Disable updates", "ultimate-security")}</option>
                                            </select>
                                        </div>
                                    </div>     
                                </div>

                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Automatic Translation Updates", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.updates.disable_translation_updates"
                                            checked={settingData?.security?.updates?.disable_translation_updates} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Enable updates for VCS Installations", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.updates.vcs_updates"
                                            checked={settingData?.security?.updates?.vcs_updates} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Updates nags only for Admin", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.updates.admin_update_nags"
                                            checked={settingData?.security?.updates?.admin_update_nags} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Email Notifications", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Email notifications are send once a day, you can choose what notifications to send below.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Updates nags only for Admin", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.updates.email_notifications"
                                            checked={settingData?.security?.updates?.email_notifications} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Notification Customization", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Test if you are receiving the error emails.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Email address", "ultimate-security")}</h6>
                                        </div>
                                        <div className="content-below-with-hint mt-2">
                                            <select 
                                                className="form-select"
                                                value={settingData?.security?.updates?.email_address} 
                                                onChange={(e) => handleChange('security.updates.email_address', e.target.value)}
                                            >
                                                {
                                                    Array.isArray(adminEmails) && adminEmails.length > 0  
                                                    ? adminEmails.map((email)=> (
                                                        <option key={email} value={email}>{__( email, "ultimate-security" )}</option> 
                                                        )
                                                    )
                                                    : <option value="">{__( "No Email Found", "ultimate-security" )}</option>
                                                }
                                            </select>
                                        </div>
                                    </div>    
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <TagInput 
                                                name='security.updates.notification_type' 
                                                type='tag' 
                                                initialTags={settingData?.security?.updates?.notification_type} 
                                                handleChange={handleChange} 
                                                whitelist={[
                                                    { value: "Update available", code: "update_available" },
                                                    { value: "Successful update", code: "successful_update" },
                                                ]}
                                            />
                                        </div>
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pb-lg mb-lg border-bottom">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Send Test Email", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Test if you are receiving the error emails.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="d-flex align-items-center gap-2">                                    
                                        <button
                                            type="button"
                                            className="button button-primary"
                                            onClick={() => handleAction('test_email')}
                                            disabled={ui.email.processing}
                                        >
                                            {ui.email.processing
                                                ? __('Processing…', 'ultimate-security')
                                                : __('Send Test', 'ultimate-security')}
                                        </button>

                                        {/* Only show the ring for email action */}
                                        {ui.email.ring && (
                                            <span className="lds-ring">
                                                <span></span><span></span><span></span><span></span>
                                            </span>
                                        )}

                                        {/* Only show the success tick for email action */}
                                        {ui.email.tick && (
                                            <img src={ultimate_security_ajax_obj.imageUrl + 'success-tick.svg'} alt="Success" />
                                        )}

                                        </div>
                                        <InfoBox className="small-infobox mt-2" title={__( "Note", "ultimate-security" )} content={__( "Don't forget to check your spam emails.", "ultimate-security" )} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pb-lg mb-lg border-bottom">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Default WordPress Core Email Notification", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Core notifications", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.updates.core_notifications"
                                            checked={settingData?.security?.updates?.core_notifications} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <InfoBox className="small-infobox mt-2" title={__( "Note", "ultimate-security" )} content={__( "Core notifications are handled by WordPress and not by this plugin.You can only disable them, changing your email address in the settings above will not affect these notifications.", "ultimate-security" )} />
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pt-lg px-lg border-top" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                        <PageHeading 
                            title={__("Advanced Options", "ultimate-security")}
                            subtitle={__("Below you will find avanced options regarding your plugins, theme, and other WordPress updates. Process with caution.", "ultimate-security")}
                        />
                    </div>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Force Automatic Updates", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div className="d-flex align-items-center gap-2">                                    
                                            <button
                                                type="button"
                                                className="button button-link"
                                                onClick={() => handleAction('force_update')}
                                                disabled={ui.update.processing}
                                            >
                                                {ui.update.processing
                                                    ? __('Processing…', 'ultimate-security')
                                                    : __('Force update', 'ultimate-security')}
                                            </button>

                                            {ui.update.ring && (
                                                <span className="lds-ring">
                                                    <span></span><span></span><span></span><span></span>
                                                </span>
                                            )}

                                            {ui.update.tick && (
                                                <img src={ultimate_security_ajax_obj.imageUrl + 'success-tick.svg'} alt="Success" />
                                            )}

                                            </div>
                                        </div>
                                    </div>     
                                </div>
                                <InfoBox className="small-infobox mt-2" title={__( "Note", "ultimate-security" )} content={__( "This will force an automatic update of your plugins, themes, and core.", "ultimate-security" )} />
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                selectedFilter ==  "plugins_list" && 
                <>
                    <div className="setting-unit">
                        <PageHeading 
                            title={__("Installed Plugins List", "ultimate-security")}
                            subtitle={__("Below you will find all the available plugins found in your WordPress site.", "ultimate-security")}
                        />
                    </div>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="user-datatable datatable-unit"> 
                            <div className="row justify-content-between mb-lg">
                                <div className="col-8 filters">   
                                    <div className="d-flex flex-wrap wp-roles">
                                        <span
                                            onClick={() => handlePluginFilter('All')}
                                            className={activePluginFilter === '' ? 'active' : ''} // Apply active class conditionally
                                        >{__( 'All', 'ultimate-security' )}</span>
                                        {
                                            filterList && filterList.map((item, index)=> (  
                                            <span 
                                                key={item.key} 
                                                value={item.key} 
                                                onClick={() => handlePluginFilter(item.key)}
                                                className={activePluginFilter === item.key ? 'active' : ''} // Apply active class conditionally
                                            >
                                            {item.value}
                                            </span>                                        
                                            ))      
                                        }
                                    </div>   
                                    <div className="bulk-action-wrapper">
                                        <select value={bulkAction} name="action"  onChange={handleBulkActionChange}>
                                            <option value="-1">{__( 'Bulk actions', 'ultimate-security' )}</option>
                                            <option value="reset">{__( 'Reset', 'ultimate-security' )}</option>
                                            <option value="delete">{__( 'Delete', 'ultimate-security' )}</option>
                                        </select>
                                        <button className="button button-secondary" onClick={handleBulkActionSubmit}>Apply</button>
                                    </div>                   
                                </div>
                                <div className="col-auto">
                                    <div className="search-unit d-flex gap-2 align-items-center">
                                        <label htmlFor="">{__( 'Search', 'ultimate-security' )}</label>
                                        <input placeholder="Search Plugins" type="search" onChange={handlePluginSearch} value={pluginSearchQuery} />
                                    </div>
                                    <div className="action-buttons d-flex align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <span 
                                                onClick={handleClickPluginRefresh}
                                                style={{ 
                                                    cursor: ui.pluginRefresh.processing ? 'not-allowed' : 'pointer',
                                                    opacity: ui.pluginRefresh.processing ? 0.6 : 1
                                                }}
                                            >
                                                {ui.pluginRefresh.processing 
                                                    ? __('Refreshing...', 'ultimate-security')
                                                    : __('Refresh for updated list', 'ultimate-security')
                                                }
                                            </span>
                                            
                                           

                                            {ui.pluginRefresh.tick && (
                                                <img src={ultimate_security_ajax_obj.imageUrl + 'success-tick.svg'} alt="Success" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>                   
                            <div className="table-wrapper">
                                <DataTable
                                    columns={pluginListColumns}
                                    data={pluginRecords}
                                    selectableRows // for making row selectable
                                    onSelectedRowsChange={handleSelectedRowsChange} // Handle row selection changes  
                                
                                    pagination
                                    dense
                                    responsive
                                />
                            </div> 
                        </div>               
                    </div>
                </>
            }
            {
                selectedFilter ==  "theme_list" && 
                <>
                    <div className="setting-unit">
                        <PageHeading 
                            title={__("Installed Themes List", "ultimate-security")}
                            subtitle={__("Below you will find all the available themes found in your WordPress site.", "ultimate-security")}
                        />
                    </div>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="user-datatable datatable-unit">   
                            <div className="row justify-content-between mb-lg">
                                <div className="col-8 filters">  
                                <div className="d-flex flex-wrap wp-roles">
                                        <span
                                            onClick={() => handleThemeFilter('All')}
                                            className={activeThemeFilter === '' ? 'active' : ''} // Apply active class conditionally
                                        >{__( 'All', 'ultimate-security' )}</span>
                                        {
                                            filterList && filterList.map((item, index)=> (  
                                            <span 
                                                key={item.key} 
                                                value={item.key} 
                                                onClick={() => handleThemeFilter(item.key)}
                                                className={activeThemeFilter === item.key ? 'active' : ''} // Apply active class conditionally
                                            >
                                            {item.value}
                                            </span>                                        
                                            ))      
                                        }
                                    </div>   
                                    <div className="bulk-action-wrapper">
                                        <select value={bulkAction} name="action"  onChange={handleBulkActionChange}>
                                            <option value="-1">{__( 'Bulk actions', 'ultimate-security' )}</option>
                                            <option value="reset">{__( 'Reset', 'ultimate-security' )}</option>
                                            <option value="delete">{__( 'Delete', 'ultimate-security' )}</option>
                                        </select>
                                        <button className="button button-secondary" onClick={handleBulkActionSubmit}>Apply</button>
                                    </div>                         
                                </div>
                                <div className="col-auto">
                                    <div className="search-unit d-flex gap-2 align-items-center">
                                        <label htmlFor="">{__( 'Search', 'ultimate-security' )}</label>
                                        <input placeholder="Search Themes" type="search" onChange={handleThemeSearch} value={themeSearchQuery} />
                                    </div>
                                    <div className="action-buttons d-flex align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <span 
                                                onClick={handleClickThemeRefresh}
                                                style={{ 
                                                    cursor: ui.themeRefresh.processing ? 'not-allowed' : 'pointer',
                                                    opacity: ui.themeRefresh.processing ? 0.6 : 1
                                                }}
                                            >
                                                {ui.themeRefresh.processing 
                                                    ? __('Refreshing...', 'ultimate-security')
                                                    : __('Refresh for updated list', 'ultimate-security')
                                                }
                                            </span>
                                            
                                           

                                            {ui.themeRefresh.tick && (
                                                <img src={ultimate_security_ajax_obj.imageUrl + 'success-tick.svg'} alt="Success" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>                 
                            <div className="table-wrapper">
                                <DataTable
                                    columns={themeListColumns}
                                    data={themeRecords}
                                    selectableRows // for making row selectable
                                    onSelectedRowsChange={handleSelectedRowsChange} // Handle row selection changes  
                                    pagination
                                    dense
                                    responsive
                                />
                            </div> 
                        </div>               
                    </div>
                </>
            }
        </>
    )
}
export default withForm(SecurityUpdates, 'security.updates');